module.exports = __webpack_public_path__ + "img/12.e2219d32.jpg";